import * as React from 'react';

import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';

import { connect } from 'react-redux';

interface PrivateRouteContainerProps {
  component: any;
  exact: boolean;
  isAuthentificated: boolean;
  path: string;
}

class PrivateRouteContainer extends React.Component<PrivateRouteContainerProps> {
  render() {
    const {
      isAuthentificated,
      component: Component,
      ...props
    } = this.props;
    
    return (
      <Route
        {...props}
        render={renderProps =>
          isAuthentificated
            ? (<Component {...renderProps} />)
            : (
            <Redirect 
              to={{
                pathname: '/login',
                state: { from: renderProps.location }
              }} 
            />
          )
        }
      />
    );
  }
}

export const PrivateRoute = connect((state: any) => ({
  isAuthentificated: state.authenticator.isAuthentificated,
}))(PrivateRouteContainer);